module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/subject-art-icon-119eb36abe6e82042c888aefbd5d06e1.svg";